import { render, staticRenderFns } from "./BlocksMenu.vue?vue&type=template&id=d1662b6c&scoped=true&"
import script from "./BlocksMenu.vue?vue&type=script&lang=js&"
export * from "./BlocksMenu.vue?vue&type=script&lang=js&"
import style0 from "./BlocksMenu.vue?vue&type=style&index=0&id=d1662b6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1662b6c",
  null
  
)

export default component.exports